import {UserContact, UserContactPatch} from "../../../types/domain.ts";
import {baseRequestService} from "../../base.ts";

export const usersUserIdContactsContactIdPatch = (userId: number, contactId: string, data: UserContactPatch) =>
    baseRequestService<UserContact>({
        url: `/users/${userId}/contacts/${contactId}`,
        method: 'PATCH',
        data
    })